import * as React from 'react';
export function useLazyRender(visible) {
    var _a = React.useState(false), isInited = _a[0], setIsInited = _a[1];
    React.useEffect(function () {
        if (visible) {
            setIsInited(visible);
        }
    }, [visible]);
    return function (render) { return function () {
        return isInited ? render() : null;
    }; };
}
